import { createSlice } from "@reduxjs/toolkit";

export const ModalTypes = {
  LOGIN: "login",
  SIGNUP: "signup",
  RESET_PASSWORD: "resetPassword",
  EMAIL_VERIFICATION: "emailVerification",
  STRIPE_ONBOARDING_COMPLETE: 'stripeOnboardingComplete',
  COURSE_COMPLETION: 'courseCompletion'
};
const initialState = {
  isOpenModal: false,
  chooseModal: null,
  email:null,
  selectedRouteBeforeVerified:''
};
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    chooseModalLogin: (state) => {
      state.chooseModal = ModalTypes.LOGIN;
      state.isOpenModal = true;
    },
    chooseModalSignUp: (state) => {
      state.chooseModal = ModalTypes.SIGNUP;
      state.isOpenModal = true;
    },
    chooseModalResetPass: (state) => {
      state.chooseModal = ModalTypes.RESET_PASSWORD;
      state.isOpenModal = true;
    },
    chooseModalEmailVerify: (state) => {
      state.chooseModal = ModalTypes.EMAIL_VERIFICATION;
      state.isOpenModal = true;
    },
    chooseStripeOnboardingCompleteModal: (state) => {
      state.chooseModal = ModalTypes.STRIPE_ONBOARDING_COMPLETE;
      state.isOpenModal = true;
    },
    chooseCourseCompletionModal: (state) => {
      state.chooseModal = ModalTypes.COURSE_COMPLETION;
      state.isOpenModal = true;
    },
    closeChooseModal: (state) => {
      state.chooseModal = null;
      state.isOpenModal = false;
    },
    setSelectedRoute: (state,action) => {
      state.selectedRouteBeforeVerified = action.payload;
    },
    setEmail: (state,action) => {
      state.email = action.payload;
    },
},
});
export const {
  chooseModalLogin,
  chooseModalSignUp,
  chooseModalResetPass,
  chooseModalEmailVerify,
  chooseStripeOnboardingCompleteModal,
  closeChooseModal,
  setSelectedRoute,
  setEmail,
  chooseCourseCompletionModal
} = authSlice.actions;
export default authSlice.reducer;
